(() => {
  if (window.jiMarqueeTapPause) return;
  window.jiMarqueeTapPause = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = (root) => {
    root.querySelectorAll('[data-ji-marquee]').forEach((marquee) => {
      if (marquee.hasAttribute('data-marquee-ready')) return;
      const toggle = marquee.querySelector('.ji-marquee__toggle');
      if (!toggle) return;
      let userPaused = false;
      const update = () => {
        const paused = motion.matches || userPaused;
        marquee.dataset.paused = String(paused);
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.disabled = motion.matches;
        toggle.title = motion.matches
          ? 'Scrolling paused for your reduced motion preference'
          : paused ? 'Tap to resume scrolling' : 'Tap to pause scrolling';
      };
      // Native button activation covers click, touch, Enter and Space.
      // Links are siblings above this button, so their navigation is untouched.
      toggle.addEventListener('click', () => {
        if (motion.matches) return;
        userPaused = !userPaused;
        update();
      });
      motion.addEventListener('change', update);
      update();
      marquee.setAttribute('data-marquee-ready', '');
      toggle.hidden = false;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
